export default __webpack_public_path__ + "static/media/bunt_coin.d11c0459.png";